import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as highlightCorrectSummaryServices from '@iso/services/listening/highlightCorrectSummary';

//#region CRUD
export function* getHighlightCorrectSummary() {
	yield takeLatest(actions.GET_HIGHLIGHT_CORRECT_SUMMARY, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(highlightCorrectSummaryServices.getHighlightCorrectSummary, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_HIGHLIGHT_CORRECT_SUMMARY_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* getHighlightCorrectSummaryDetail() {
	yield takeLatest(actions.GET_HIGHLIGHT_CORRECT_SUMMARY_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(highlightCorrectSummaryServices.getHighlightCorrectSummaryDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_HIGHLIGHT_CORRECT_SUMMARY_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesHighlightCorrectSummary() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_HIGHLIGHT_CORRECT_SUMMARY, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(highlightCorrectSummaryServices.createQuesHighlightCorrectSummary, body);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}

		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* updateHighlightCorrectSummaryDetail() {
	yield takeLatest(actions.UPDATE_HIGHLIGHT_CORRECT_SUMMARY_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(highlightCorrectSummaryServices.updateHighlightCorrectSummaryDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteHighlightCorrectSummary() {
	yield takeLatest(actions.DELETE_HIGHLIGHT_CORRECT_SUMMARY, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(highlightCorrectSummaryServices.deleteHighlightCorrectSummary, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getHighlightCorrectSummary),
		fork(getHighlightCorrectSummaryDetail),
		fork(createQuesHighlightCorrectSummary),
		fork(updateHighlightCorrectSummaryDetail),
		fork(deleteHighlightCorrectSummary),
	]);
}
